<template>
  <div id="nom_intro_voting_intermission">
    
    <h4>Nominations are currently closed</h4>

    <p>
      Nominations and voting have ended for this year's contest and we're eagerly counting the votes to find out who you picked for this year's "Bests".
    </p>

    <div class="iframe_container">
      <iframe src="https://giphy.com/embed/Bp5dwyOW9BwbK" width="100%" height="200" frameBorder="0" class="giphy-embed" allowFullScreen></iframe><a href="https://giphy.com/gifs/Bp5dwyOW9BwbK">via GIPHY</a>
    </div>

    <p>
      Use the big button below to head on over to our "winners" section to learn more about when winners will be announced and how you can be notified as soon as they're posted.
    </p>

  </div>
</template>

<script>
import StoryList from '@/components/lists/story_list.vue';

export default {
  name: 'nom_intro_voting_intermission',
  props: [
    'nom_start_date',
    'tz_offset'
  ],
  data () {
    return {
      
    }
  },
  computed: {
    
  },
  methods: {

  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.iframe_container {
  margin-bottom: 1em;
}
</style>


// WEBPACK FOOTER //
// src/features/nominate/intros/nom_intro_voting_intermission.vue